<template>
  <el-dialog @open="open" :title="tituloDialog" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="40%">
    <el-form :model="contatoForm" :rules="validacao" ref="form" size="small" label-position="top" style="margin: -20px 0px 0px 0px" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Tipo" prop="tipo">
            <el-select v-model="contatoForm.tipo" value-key="data" placeholder="Selecione o tipo" 
            default-first-option style="width: 100%">
              <el-option v-for="item in tiposContatos" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Nome" prop="nome">
            <el-input v-model="contatoForm.nome" placeholder="Informe o nome do contato"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Telefone" prop="telefone">
            <el-input v-model="contatoForm.telefone" v-mask="['(##) ####-####']" placeholder="(DDD) XXXX-XXXX"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Celular">
            <el-input v-model="contatoForm.celular" v-mask="['(##) #####-####']" placeholder="(DDD) 9XXXX-XXXX"/>
          </el-form-item>
        </el-col>
      </el-row> 

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="E-mail" prop="email">
            <el-input v-model="contatoForm.email" placeholder="exemplo@email.com"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarHandler" type="primary" size="small" round class="btn-box-shadow">{{ tituloBotao }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

import { EMAIL_REGEX, TIPOS_CONTATOS } from '../../util/constantes'
export default {
  props: {
    index: Number,
    contato: Object,      
    visibility: Boolean,
    operacao: String
  },
  data() {
    return {
      validacao: {
        tipo: [
          { required: true, message: "Tipo é obrigatório" }
        ],
        nome: [
          { type: "string", required: true, whitespace: true, message: "Nome é obrigatório" }
        ],
        email: [
          { pattern: EMAIL_REGEX }
        ]
      },
      contatoForm: {
        tipo: undefined,
        nome: undefined,
        telefone: undefined,
        celular: undefined,
        email: undefined
      }
    }
  },  
  computed: {
    ...mapState('alugueisClientesStore', {
      clienteAluguel(state) { return state.clienteSelecionado },
      }),
    ...mapState('vendasClientesStore',{
      clienteVenda(state) { return state.clienteSelecionado }
    }),
    tiposContatos() {
      return TIPOS_CONTATOS;
    },
    tituloBotao() {
      if(this.contatoForm.id >= 0) {
        return 'Gravar'
      } else {
        return 'Adicionar'
      }
    },
    tituloDialog() {
      if(this.contatoForm.id >= 0){
        return 'Alterar Contato Adicional';
      } 
      else{
       return 'Adicionar Contato';
      } 
    }

  },
  methods: {
    reset() {
      this.contatoForm = {
        nome: undefined,
        tipo: undefined,
        telefone: undefined,
        celular: undefined,
        email: undefined
      };
      this.$refs['form'].resetFields();
    },
    gravarHandler() {
      if(this.contatoForm.id >= 0) {
        this.editar();
      } else {
        this.adicionar();
      }
    },
    editar() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          let payload = {
            id: this.contatoForm.id,
            nome: this.contatoForm.nome,
            tipo: this.contatoForm.tipo,
            telefone: this.contatoForm.telefone,
            celular: this.contatoForm.celular,
            email: this.contatoForm.email
          };
          if(this.operacao === 'ALUGUEL') {
            this.clienteAluguel.contatosAlternativos.splice(this.index, 1);
            this.clienteAluguel.contatosAlternativos.push(payload);
          } else if(this.operacao === 'VENDA') {
            this.clienteVenda.contatosAlternativos.splice(this.index, 1);
            this.clienteVenda.contatosAlternativos.push(payload);
          }
          this.fechar();
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    adicionar() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          let payload = {
            id: 0,
            nome: this.contatoForm.nome,
            tipo: this.contatoForm.tipo,
            telefone: this.contatoForm.telefone,
            celular: this.contatoForm.celular,
            email: this.contatoForm.email
          };
          if(this.operacao === 'ALUGUEL') {
            this.clienteAluguel.contatosAlternativos.push(payload);
          } else if(this.operacao === 'VENDA') {
            this.clienteVenda.contatosAlternativos.push(payload);
          }
          this.fechar();
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    fechar() {
      this.reset();
      this.$emit('close');
    },
    open() {
      if(this.contato.id >= 0) {
        this.contatoForm = this.contato
      }
    }
  }
}
</script>

<style scoped>
  .el-dialog {
    width: 300px !important;
  }
</style>